// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gLS3A","col":"styles_col__Bwkwv"};